import { render, staticRenderFns } from "./ContainerPage.vue?vue&type=template&id=533a2abd&"
import script from "./ContainerPage.vue?vue&type=script&lang=js&"
export * from "./ContainerPage.vue?vue&type=script&lang=js&"
import style0 from "./ContainerPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports